import './ListMap.scss';
import Component from './ListMap.js';
export default Component;
